import { updateRendezVous } from "../../store/slices/rendezVousSlice";
import {
  fetchCalendarData,
  fetchDemandesRendezvous,
} from "../../store/slices/rendezVousPrestaSlice";
import { toast } from "react-toastify";

export const handleAcceptationRdv = async (
  dispatch,
  rendezVous,
  handleClose,
  demande = false
) => {
  try {
    const updatedRdv = {
      id: rendezVous.id,
      status: "confirme",
    };

    await dispatch(updateRendezVous(updatedRdv)).unwrap();
    await dispatch(fetchCalendarData());
    // console.log("demande", demande);
    if (demande) {
      toast.success("La demande de rendez-vous est acceptée ");
    } else {
      toast.success("Rendez-vous accepté avec succès");
    }

    if (handleClose) handleClose();
  } catch (error) {
    // console.error("Erreur lors de l'acceptation :", error);
  }
};
